<template>
  <v-container>
    <v-row
      style="display: flex; flex-direction: column"
      @keydown.esc="cancel()"
    >
      <Header :items="items"
        ><template slot="title">
          {{ $tc("assignCards.title") }}
        </template></Header
      >
      <v-col>
        <v-dialog v-model="showAdd" max-width="590px">
          <template v-slot:activator="{ on, attrs }">
            <div style="display: flex; justify-content: flex-end">
              <v-btn
                rounded
                class="btn-add mr-5"
                :title="$tc('editRegistrations.add')"
                @click="openAdd"
              >
                {{ $tc("editRegistrations.add") }}
                <v-icon small class="ml-1" color="white" dark> fa-plus </v-icon>
              </v-btn>
            </div>
          </template>
          <CardDialog>
            <template slot="title"> {{ $tc("assignCards.add") }} </template>
            <template slot="body">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-form ref="form" v-model="valid" lazy-validation class="mt-2">
                <v-autocomplete
                  required
                  :rules="rules"
                  v-model="data.card"
                  outlined
                  :label="$tc('assignCards.card')"
                  :items="getCardsAdd"
                  item-value="cardId"
                  item-text="card"
                  class="mx-2"
                />
                <date class="mx-2" />
              </v-form>
              <div class="d-flex justify-space-between mt-8 mb-n4 mx-2">
                <v-btn class="bt-exit" @click="cancel()"
                  >{{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click.prevent="validate"
                  >{{ $tc("editRegistrations.acept") }}
                </v-btn>
              </div>
            </template>
          </CardDialog>
        </v-dialog>

        <v-dialog v-model="showDelete" max-width="350px">
          <CardDialog style="max-width: 350px; overflow: hidden">
            <template slot="title">
              {{ $tc("assignCards.deleteCard") }}
            </template>

            <template slot="actions">
              <v-btn class="bt-exit" @click="showDelete = false"
                >{{ $tc("editRegistrations.cancel") }}
              </v-btn>
              <v-btn class="bt-acept" @click.prevent="deleteItem">
                {{ $tc("editRegistrations.delete") }}</v-btn
              >
            </template>
          </CardDialog>
        </v-dialog>

        <v-dialog v-model="showEdit" max-width="590px">
          <CardDialog style="max-width: 600px; overflow: hidden">
            <template slot="title"> {{ $tc("assignCards.edit") }} </template>
            <template slot="body">
              <v-alert
                dense
                v-if="error"
                color="red"
                elevation="5"
                outlined
                text
                type="error"
                align="center"
                class="mr-1 ml-1"
              >
                {{ alertValidate }}</v-alert
              >
              <v-form ref="formEdit" v-model="validateEdit" lazy-validation>
                <v-autocomplete
                  v-model="editItems.cardId"
                  outlined
                  :label="$tc('assignCards.card')"
                  :items="getCards"
                  item-value="cardId"
                  item-text="card"
                  disabled
                  class="mx-2"
                />
                <date class="mx-2" />
              </v-form>
              <div class="d-flex justify-space-between mt-8 mb-n4 mx-2">
                <v-btn class="bt-exit" @click="cancel"
                  >{{ $tc("editRegistrations.cancel") }}
                </v-btn>
                <v-btn class="bt-acept" @click.prevent="validEdit">
                  {{ $tc("editRegistrations.acept") }}</v-btn
                >
              </div>
            </template>
          </CardDialog>
        </v-dialog>

        <DataTable
          :itemsPerPage="5"
          :items="getCards"
          :headers="headers"
          :openEdit="openEdit"
          :openDelete="openDelete"
          :loader="loader"
          :action="true"
          :openAction="openAction"
        />
      </v-col>
      <v-dialog v-model="dialogBookingErros" max-width="800px" persistent>
        <v-card class="card-errors">
          <v-card-title
            style="display: flex; justify-content: center"
            class="title-table"
          >
            {{ $tc("assignCards.tableErrors") }}</v-card-title
          >
          <v-card-text>
            <DataTable
              :repairErrors="repairErrors"
              :itemsPerPage="5"
              :tool="true"
              :headers="headersBookingErros"
              :items="getErrors"
            />
          </v-card-text>
          <v-card-actions
            style="display: flex; justify-content: center; align-items: center"
          >
            <v-btn class="bt-exit" @click="dialogBookingErros = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-snackbar v-model="alertOk" color="#909DFA" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="alertOk = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="alertError" color="#FF8D58" bottom rounded="pill">
      {{ textAlert }}
      <template v-slot:action="{ attrs }">
        <v-btn color="black" text v-bind="attrs" @click="alertError = false">
          {{ $tc("newController.close") }}
        </v-btn>
      </template>
    </v-snackbar>
    <v-dialog v-model="isLoading" class="dialog__loader" :overlay-opacity="0.3">
      <LoaderComponent :loading="isLoading" />
    </v-dialog>
  </v-container>
</template>

<script>
import Header from "./common/Header.vue";
import DataTable from "./common/DataTable.vue";
import CardDialog from "./common/CardDialog.vue";
import registrations from "../../../store/gestionTiempos/registrations";
import resultSettlementHours from "../../../store/gestionTiempos/resultSettlementHours";
import Date from "./common/DateRegis.vue";
import moment from "moment";
import LoaderComponent from "../../Complement/Loader.vue";

export default {
  components: { Header, CardDialog, DataTable, Date, LoaderComponent },
  props: {
    items: Object,
    refreshForm: Number,
  },
  data() {
    return {
      isLoading: false,
      itemsErros: [],
      dialogBookingErros: false,
      validateEdit: true,
      showEdit: false,
      loader: true,
      showAdd: false,
      error: false,
      alertValidate: "",
      alertError: false,
      showDelete: false,
      textAlert: "",
      alertOk: false,
      deleteItems: {},
      valid: true,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
      fromMenuDate: false,
      toMenuDate: false,
      editItems: {},
      data: {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        card: null,
      },
      checkTo: this.$store.state.gestionTiempos.checkTo,
      headers: [
        {
          text: "Tarjeta",
          value: "card",
          class: "primary secondary--text",
          align: "center",
          sortable: true,
        },
        {
          text: "Desde",
          value: "from",
          class: "primary secondary--text",
          align: "center",
          sortable: false,
        },
        {
          text: "Hasta",
          value: "to",
          class: "primary secondary--text",
          align: "center",
          sortable: false,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          align: "center",
          sortable: true,
        },
      ],
      headersBookingErros: [
        {
          text: "Fichada",
          value: "booked",
          class: "primary secondary--text",
          sortable: true,
        },
        {
          text: "Error",
          value: "descriptionError",
          class: "primary secondary--text",
          sortable: true,
        },
        {
          text: "Arreglar",
          value: "tools",
          class: "primary secondary--text",
          sortable: true,
        },
      ],
    };
  },
  mounted() {
    this.loader = false;
  },
  computed: {
    getCards() {
      return this.$store.state.assignCards.cards;
    },
    getCardsAdd() {
      return this.$store.state.assignCards.cardAssign;
    },
    getErrors() {
      return this.$store.state.assignCards.bookingError.item;
    },
  },
  methods: {
    //se abre el formulario de agregar
    async openAdd() {
      await this.$store.dispatch("assignCards/getCardsAssign");
      this.showAdd = true;
    },
    //se valida el formulario
    validate() {
      if (this.$store.state.gestionTiempos.checkTo) {
        this.$store.commit("gestionTiempos/setDateToComponents", null);
        this.data.to = null;
      }
      let valid = this.$refs.form.validate();
      if (valid) {
        if (this.data.from > this.data.to) {
          this.error = true;
          this.alertValidate = this.$tc("autoriz.greater");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.addAssignCard();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },
    //se agrega una nueva tarjeta
    async addAssignCard() {
      await this.$store.dispatch("assignCards/getCardsAssign");
      let cardId = this.$store.state.assignCards.cardAssign.filter((option) => {
        return option.cardId == this.data.card;
      });

      let payload = {
        cardId: this.data.card,
        card: cardId[0].card,
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        id: this.data.card + this.data.from,
      };
      this.$store.commit("assignCards/setNew", payload);
      this.$store
        .dispatch("assignCards/newCard")
        .then((r) => {
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults");
          this.$store.dispatch("changeSchedule/getScheduleElement");
          this.$store.dispatch("assignCards/getCards");
          this.textAlert = this.$tc("assignCards.alertOk");
          this.alertOk = true;
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = this.$tc("assignCards.alertError");
        });
      this.showAdd = false;
      this.reset();
    },
    //se cancela el formulario
    cancel() {
      this.error = false;
      if (this.showAdd) {
        this.showAdd = false;
        this.reset();
      } else {
        this.showEdit = false;
        this.resetEdit();
      }
    },
    //se resetea el formulario
    reset() {
      this.$refs.form.resetValidation();
      this.checkTo = false;
      const today = this.items.date
        .slice(0, 10)
        .split(/\D/)
        .reverse()
        .join("-");
      this.$store.commit("gestionTiempos/setDateFromComponents", today);
      this.$store.commit("gestionTiempos/setDateToComponents", today);
      this.$store.commit("gestionTiempos/setCheckTo", this.checkTo);
      this.data = {
        from: this.$store.state.gestionTiempos.dateFromComponents,
        to: this.$store.state.gestionTiempos.dateToComponents,
        date: this.items.date.slice(0, 10).split(/\D/).reverse().join("-"),
        card: null,
      };
      this.checkTo = false;
    },
    //se abre el formulario de eliminar
    openDelete(item) {
      this.showDelete = true;
      let from = item.from.slice(0, 10).split(/\D/).reverse().join("-");

      this.deleteItems = {
        empId: item.empId,
        tarjId: item.cardId,
        fecDesde: from,
        id: item.cardId + from + "T00:00:00.000Z",
      };
    },
    //se elimina la tarjeta
    deleteItem() {
      this.$store.commit("assignCards/setDeleteItem", this.deleteItems);
      this.$store
        .dispatch("assignCards/deleteCard")
        .then((r) => {
          this.textAlert = this.$tc("alert.okDelete");
          this.alertOk = true;
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = this.$tc("alert.errorDelete");
        });
      this.showDelete = false;
    },
    // se abre el formulario de editar
    async openEdit(item) {
      this.$store.commit(
        "gestionTiempos/setDateFromComponents",
        moment(item.from, "DD-MM-YYYY").format("YYYY-MM-DD"),
      );

      if (item.to !== " " && item.to !== null) {
        this.$store.commit("gestionTiempos/setCheckTo", false);
        this.$store.commit(
          "gestionTiempos/setDateToComponents",
          moment(item.to, "DD-MM-YYYY").format("YYYY-MM-DD"),
        );
      } else {
        this.$store.commit("gestionTiempos/setCheckTo", true);
      }

      setTimeout(() => {
        this.showEdit = true;
      }, 5000);
      await this.$store.dispatch("assignCards/getCards");
      let cardId = this.$store.state.assignCards.cards.filter((option) => {
        return option.cardId == item.cardId;
      });
      let to =
        item.to !== " "
          ? item.to.slice(0, 10).split(/\D/).reverse().join("-")
          : null;

      this.editItems = {
        from: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
        to: to,
        cardId: cardId[0].cardId,
        card: cardId[0].card,
        id: item.id,
        originFrom: item.from.slice(0, 10).split(/\D/).reverse().join("-"),
      };
    },
    //se valida el formulario de edicion
    validEdit() {
      let valid = this.$refs.formEdit.validate();
      if (valid) {
        if (this.editItems.from > this.editItems.to) {
          this.error = true;
          this.alertValidate = this.$tc("autoriz.greater");
          setTimeout(() => {
            this.error = false;
          }, 2500);
        } else {
          this.editAssignCard();
        }
      } else {
        this.error = true;
        this.alertValidate = this.$tc("editRegistrations.required");
        setTimeout(() => {
          this.error = false;
        }, 2500);
      }
    },

    editAssignCard() {
      this.editItems.from1 =
        this.$store.state.gestionTiempos.dateFromComponents;
      this.editItems.to1 = this.$store.state.gestionTiempos.dateToComponents;
      if (this.$store.state.gestionTiempos.checkTo) {
        this.editItems.haNoEx = true;
        this.editItems.to1 = null;
      }
      this.$store.commit("assignCards/setEdit", this.editItems);
      this.$store
        .dispatch("assignCards/edit")
        .then((r) => {
          registrations.dispatch("getRegistrations");
          resultSettlementHours.dispatch("getResults");
          this.$store.dispatch("changeSchedule/getScheduleElement");
          this.$store.dispatch("assignCards/getCards");
          this.textAlert = this.$tc("alert.okEdit");
          this.alertOk = true;
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = this.$tc("alert.errorEdit");
        });
      this.showEdit = false;
      this.resetEdit();
    },
    // se resetea el formulario de edicion
    resetEdit() {
      this.$refs.formEdit.resetValidation();
      this.checkTo = false;
    },
    //se abre el dialogo de errores
    async openAction(item) {
      this.isLoading = true;

      this.itemsErros = item.card.trim();

      await this.dispatchRepair();
    },
    //se hace el dispatch para reparar el error
    async dispatchRepair() {
      this.$store.commit("assignCards/setBookingError", this.itemsErros);
      this.$store
        .dispatch("assignCards/getBookingError")
        .then(() => {
          this.isLoading = false;
          this.dialogBookingErros = true;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    //se repara el error
    repairErrors(item) {
      let payload = {
        linea: item.linea,
        procId: item.procId,
        empId: parseInt(localStorage.getItem("empId"), 10),
        operId: parseInt(localStorage.getItem("operId"), 10),
        fecha:
          this.items.date.slice(0, 10).split(/\D/).reverse().join("-") +
          "T00:00:00.000Z",
      };
      this.$store.commit("assignCards/setRepairError", payload);
      this.$store
        .dispatch("assignCards/repairError")
        .then((e) => {
          this.dispatchRepair();
          this.textAlert = this.$tc("assignCards.repairOk");
          this.alertOk = true;
        })
        .catch((e) => {
          this.alertError = true;
          this.textAlert = this.$tc("assignCards.reopairError");
        });
    },
  },
};
</script>

<style scoped>
.title-table {
  color: #39537a !important;
  font-weight: lighter !important;
  margin-bottom: 20px !important;
  text-shadow: 1px 1px #384b6d;
}

.card-errors {
  background-color: #ffffffa9;
  border-radius: 10px;
}
.btn-add {
  background-color: #39537a !important;
  color: white !important;
  margin-left: 50px !important;
}

.bt-acept {
  background-color: #77dd77 !important;
  color: white !important;
}
.bt-exit {
  color: white !important;
  background-color: #e2504c !important;
}
</style>
